import { render, staticRenderFns } from "./ExportHistoricoAgenciaPorDniPage.vue?vue&type=template&id=cb92ea86&scoped=true"
import script from "./ExportHistoricoAgenciaPorDniPage.vue?vue&type=script&lang=js"
export * from "./ExportHistoricoAgenciaPorDniPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb92ea86",
  null
  
)

export default component.exports